import { OptionalBaseProps } from './BaseProps';
import Constants from '../utils/Constants';

const defaultBaseProps: OptionalBaseProps = {
  buttonPlacement: 'outsideOfInputs',
  className: undefined,
  focusColor: '#85b7d9',
  doubleClickDelayInMillis: Constants.DOUBLE_CLICK_DELAY_IN_MILLIS,
  id: undefined,
  showTooltipDelayInMillis: Constants.SHOW_TOOLTIP_DELAY_IN_MILLIS,
  showTooltips: true,
  size: 'small'
};

export default defaultBaseProps;
